<template>
    <div>
        <Crumbs></Crumbs>
        <div class="mainList">
            <div class="mainList_operation clearfloat">
                <div class="mainList_operation_search">
                    <el-select class="item" v-model="parameter.type">
                        <el-option label="请选择类型" value=""></el-option>
                        <el-option label="书籍" value="1"></el-option>
                        <el-option label="笔记" value="2"></el-option>
                        <el-option label="行业交流" value="3"></el-option>
                    </el-select>
                    <el-select class="item" v-model="parameter.status">
                        <el-option label="请选择审核状态" value=""></el-option>
                        <!-- <el-option label="待审核" value="0"></el-option>-->
                        <el-option label="审核通过" value="1"></el-option>
                        <el-option label="驳回" value="2"></el-option>
                    </el-select>
                    <el-button type="primary" plain icon="el-icon-search" @click="pageChangeHandler(1)">搜索</el-button>
                </div>
                <div class="fr">
                    <template  v-if="selectRows.length>0">
                        <el-button type="danger" @click="handleDelete">批量删除</el-button>
                        <el-button type="danger"  @click="handleEdit()" >批量设置状态</el-button>
                    </template>
                </div>
            </div>
            <div class="mainList_content">
                <div class="mainList_content_sub">
                    <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" height="string" v-loading="loading" @selection-change="setSelectRows">
                        <el-table-column align="center" show-overflow-tooltip type="selection"></el-table-column>
                        <el-table-column label="序号" type="index" align="center" width="70"></el-table-column>
                        <el-table-column align="center" prop="content" label="内容"></el-table-column>
                        <el-table-column align="center" prop="give_praise_num" label="点赞数"></el-table-column>
                        <el-table-column align="center" prop="nickname" label="发布昵称"></el-table-column>

                        <el-table-column label="类型"  align="center" width="160" fixed="right" >
                            <template slot-scope="scope">
                                {{  scope.row.type | showType  }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态"  align="center" width="160" fixed="right" >
                            <template slot-scope="scope">
                                {{  scope.row.status | showStatus  }}
                            </template>
                        </el-table-column>

                        <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>

                        <el-table-column align="center" prop="update_time" label="更新时间"></el-table-column>

                        <el-table-column label="操作"  align="center" width="160" fixed="right" >
                            <template slot-scope="scope">

                                <el-button type="text" size="small" @click="handleDelete(scope.row)" >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="pageChangeHandler"
                        :current-page.sync="parameter.page_no"
                        :page-size="parameter.page_size"
                        prev-text="上一页"
                        next-text="下一页"
                        :total="parameter.total_result">
                    </el-pagination>
                </div>
            </div>
        </div>
      <Edit :isShow.sync="showEditDialog" :options="options"></Edit>
    </div>
</template>
<script>


export default {
    components: {
       Edit: () => import("./Edit.vue"),
        Crumbs: () => import("@/components/Crumbs.vue"),
    },
    data() {
        return {
            parameter:{
                method:'get.ask.list',
                page_no:1,
                page_size:50,
                total_result:0,
                title:''

            },
            selectRows:[],
            activeData:{},
            options: {},
            tableData: [],
            loading: false,
            showEditDialog: false,
        };
    },
    provide () {
        return {
            refresh:this.refresh,
        }
    },

    filters:{
        showType(val){
            if(val==1){
                return  "老师";
            }else if(val==2){
                return  "机构";
            }
        },
        showStatus(val){
            //0:待审核 1:审核通过 2:驳回
            if(val==0){
                return  "待审核";
            }else if(val==1){
                return  "审核通过";
            }else{
                return  "驳回";
            }

        }
    },
    watch: {},
    created() {
        this.getData();

    },
    methods: {
        setSelectRows(val) {
            this.selectRows = val
        },
        refresh(){
            this.showEditDialog = false;
            this.pageChangeHandler(1);
        },
        pageChangeHandler(val) {
            this.parameter.page_no = val;
            this.getData();
        },
        handleSizeChange(val){
            this.parameter.page_size = val;
            this.parameter.page_no = 1;
            this.getData();
        },
        handleEdit() {
            const ids=[];
           // const names=[];
            if (this.selectRows.length > 0) {
                const itemIds = this.selectRows.map((item) => item.ask_id);
                //const itemNames = this.selectRows.map((item) => item.ask_id);
                for (var i = 0; i < itemIds.length; i++) {
                    ids.push(itemIds[i]);
                }
               /* for (var i = 0; i < itemNames.length; i++) {
                    names.push(itemNames[i]);
                }*/
            } else {
                this.$message.error('未选中任何行');
                return false
            }
            const paramsScope={ask_id:ids};
            this.options = paramsScope;
            this.showEditDialog = true

        },
        add() {
            this.options = {};
            this.showEditDialog = true

        },
        getData() {
            this.loading = true;
            this.$api.ask.ask(this.parameter).then(res => {
                this.loading = false;
                console.log(res.data);
                if(res.data.items&&Array.isArray(res.data.items)){
                    this.tableData = res.data.items;
                }else{
                    this.tableData =[];
                };
                this.parameter.total_result = res.data.total_result;
            }).catch(err => {
                console.log(err);
                this.loading = false;
            });
        },

        handleDelete(row) {
            const ids=[];
            if (row.ask_id) {
                ids.push(row.ask_id);
            } else {
                if (this.selectRows.length > 0) {
                    const itemIds = this.selectRows.map((item) => item.ask_id);
                    for (var i = 0; i < itemIds.length; i++) {
                        ids.push(itemIds[i]);
                    }
                } else {
                    this.$message.error('未选中任何行');
                    return false
                }
            }

            console.log(ids);
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$api.ask.ask({
                    module:'admin',
                    method:'del.ask.list',
                    'ask_id':ids,
                }).then(res => {
                    if(res.status==200){
                        this.$message.success("删除成功！");
                        var hasLastPage = this.parameter.page_size*this.parameter.page_no>=this.parameter.total_result;
                        var lastData = this.tableData.length<2;
                        if (lastData&&hasLastPage&&this.parameter.page_no>1) {
                            this.parameter.page_no --;
                        };
                        this.getData();
                    }

                }).catch(err => {
                    console.log(err);
                });
            }).catch(() => {//用户取消

            });
        },
    },
};
</script>
<style scoped lang='scss'>
@import "@/styles/config.scss";

</style>
